import React from 'react';
import { 
  HeroSection,
  CompanyStorySection,
  ValuesSection,
  StatsSection,
  TeamSection,
  CTASection,
  SEO
} from '../components';

const About = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About GrowthVibe - Leading IT & Digital Marketing Agency",
    "description": "Learn about GrowthVibe's mission, values, and team. We're your growth partner combining strategic thinking with cutting-edge technology.",
    "url": "https://growthvibe.com/about",
    "mainEntity": {
      "@type": "Organization",
      "name": "GrowthVibe",
      "foundingDate": "2024",
      "description": "Leading IT and digital marketing agency specializing in web development, SEO, social media marketing, and brand identity design.",
      "mission": "To help businesses achieve sustainable growth through innovative digital solutions and strategic marketing approaches.",
      "values": [
        "Innovation",
        "Transparency", 
        "Excellence",
        "Client Success"
      ]
    }
  };

  return (
    <>
      <SEO
        title="About GrowthVibe - Leading IT & Digital Marketing Agency"
        description="Learn about GrowthVibe's mission, values, and team. We're your growth partner combining strategic thinking with cutting-edge technology to deliver exceptional results."
        keywords="about GrowthVibe, digital marketing agency, IT company, web development team, marketing experts, company values, team members, Surat Gujarat"
        url="/about"
        structuredData={structuredData}
      />
      <div className="about-page">
        {/* Hero Section */}
      <HeroSection
        title="About GrowthVibe"
        description="At GrowthVibe, we're more than just a marketing agency — we're your growth partner. We combine strategic thinking with cutting-edge technology to deliver results that matter."
        showGradient={true}
        heroImage="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
        heroImageAlt="GrowthVibe Team - Professional Team Working Together"
        layout="centered"
      />

      {/* Company Story */}
      <CompanyStorySection />

      {/* Mission, Vision, Values */}
      <ValuesSection />

      {/* Stats */}
      {/* <StatsSection /> */}

      {/* Team */}
      <TeamSection />

      {/* CTA */}
      <CTASection 
        title="Ready to Work With Us?"
        description="Let's discuss how we can help you achieve your business goals and drive sustainable growth."
        primaryButtonText="Get Started"
        secondaryButtonText="Our Services"
        secondaryButtonLink="/services"
      />
      </div>
    </>
  );
};

export default About;
